<div class="card">
  <div class="row">
    <div class="col-12">
      <div class="card-title">
        {{ 'product.image.gallery' | translate }}
      </div>
    </div>
  </div>
  <div class="row">
    <div *ngFor="let img of product.images">
      <div
        class="img-card"
        [photoGalleryGroup]="{ index: 1 }"
        [photoGallery]="getThumbUrl(img, 'w2048wp')"
        [photoGalleryCaption]="
          img.product
            ? img.product.name +
              '<br>' +
              (img.product.code ? ('product-images.code' | translate) + img.product.code : '') +
              '<br>' +
              (img.product.ean ? ('product-images.ean' | translate) + img.product.ean : '')
            : ''
        "
      >
        <div class="img-container">
          <div>
            <img class="images-item-image" [src]="getThumbUrl(img)" [alt]="img.text" />
          </div>
          <div class="images-item-name">
            {{ img.text }}
          </div>
        </div>
      </div>
      <div>
        <btn
          [title]="'delete' | translate"
          [icon]="'far-trash-alt'"
          [classes]="['btn-trash', 'btn-sm', 'float-right', 'btn-prod-img-delete']"
          (click)="removeImage(img)"
          *ngIf="productDetailService.hasUpdateRole"
        ></btn>
      </div>
    </div>
    <div
      class="new-img-dropzone ml-2 mt-2"
      ngx-dropzone
      (change)="onSelect($event)"
      accept="image/jpeg,image/jpg,image/png,image/gif"
      *ngIf="productDetailService.hasUpdateRole"
    >
      <div class="d-flex flex-column">
        <ngx-dropzone-label *ngIf="!files || (files && !files.length)"
          ><i class="far fa-file-import"></i
        ></ngx-dropzone-label>
        <ngx-dropzone-label *ngIf="!files || (files && !files.length)">{{
          'upload.images' | translate
        }}</ngx-dropzone-label>
      </div>
      <div *ngIf="files && files.length">
        <div>
          <div>{{ progressFiles }}/{{ files.length }}</div>
          <div>
            <i>{{ progress }}%</i>
          </div>
        </div>
        <progressbar [max]="100" [value]="progress" type="success" [striped]="false" [animate]="true"></progressbar>
      </div>
    </div>
  </div>
</div>
